var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-demo",
      attrs: { "default-active": _vm.active, mode: "horizontal" },
      on: { select: _vm.handleSelect }
    },
    _vm._l(_vm.navList, function(item) {
      return _c("el-menu-item", { key: item.id, attrs: { index: item.id } }, [
        _c("img", {
          staticStyle: { "object-fit": "contain" },
          attrs: {
            src: _vm.active === item.id ? item.activeImg : item.defaultImg
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(item.name))])
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d11b8516", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d11b8516","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footNav.vue
// module id = null
// module chunks = 